import { Typography } from '@mui/material'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import React from 'react'
import InprogressTab from './InprogressTab'
import CompletedTab from './CompletedTab'

const UploadHistoryDrawer = ({ initialTab = 0, drawerState, handleDrawer }) => {
  return (
    <AdxDrawerComponent
      state={drawerState}
      anchor="right"
      onClose={handleDrawer}
      title={'Upload Log'}
      headerprops
      noPaddingContent
    >
      <AdxTabsBadge initialValue={initialTab} scrollButtons={false}>
        <AdxTabsPanel label="In progress">
          <InprogressTab isOpen={drawerState.right} />
        </AdxTabsPanel>
        <AdxTabsPanel label="Completed">
          <CompletedTab isOpen={drawerState.right} />
        </AdxTabsPanel>
      </AdxTabsBadge>
    </AdxDrawerComponent>
  )
}

export default UploadHistoryDrawer
